import { BiChevronLeft } from 'react-icons/bi';
import styled from 'styled-components';
import DateRangePicker from '../../../../components/dateRangePicker';
import ExportOptionsMenu from '../../../exports/components/exportOptionsMenu';
import useReportDataContext from '../../hooks/useReportDataContext';

const ReportHeaderSection = () => {
  const {
    reportTitle,
    handleBackNavigation,
    freezeDateRangeDropdown,
    isReportExportEnabled,
    marketingHtmlUrl
  } = useReportDataContext();

  return (
    <StyledHeaderSection className="header-section">
      <div className="subtitle-row">
        <a className="back-button" onClick={handleBackNavigation}>
          <BiChevronLeft className="icon" />
        </a>
        <h1 className="page-title">{reportTitle}</h1>
        <div className="controls">
          <DateRangePicker freeze={freezeDateRangeDropdown} />
          {!Boolean(marketingHtmlUrl) && isReportExportEnabled ? <ExportOptionsMenu /> : null}
        </div>
      </div>
    </StyledHeaderSection>
  );
};

export default ReportHeaderSection;

const StyledHeaderSection = styled.div`
  padding: 16px;
  background: ${({ theme }) => theme.body};
  border-radius: 0px 0px 8px 8px;
  margin: 16px;
  margin-top: -10px;

  .back-button {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${({ theme }) => theme.text};
    text-decoration: none;
    font-size: 24px;
    cursor: pointer;
    flex-shrink: 0;
    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.primary_color};
    }

    .icon {
      font-size: 30px;
    }
  }

  .subtitle-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  .page-title {
    color: ${({ theme }) => theme.text};
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .controls {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
    flex-shrink: 0;
  }

  /* ═══ 2-ROW (<1024px) ═══
     Row 1: Back + Title (left)
     Row 2: Datepicker + Export (right) */
  @media (max-width: 1023px) {
    padding: 12px;
    margin: 12px;

    .back-button {
      font-size: 20px;
      .icon { font-size: 24px; }
    }

    .subtitle-row {
      flex-wrap: wrap;
      gap: 10px;
    }

    .page-title {
      font-size: 20px;
    }

    .controls {
      flex: 1 1 100%;
      margin-left: 0;
      justify-content: flex-end;
    }
  }

  /* ═══ 3-ROW (<720px) ═══
     Row 1: Back + Title (left)
     Row 2: Datepicker (full width)
     Row 3: Export (full width) */
  @media (max-width: 719px) {
    padding: 10px;
    margin: 8px;
    margin-top: -5px;

    .page-title {
      font-size: 17px;
    }

    .controls {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
  }
`;
